<template>
  <section>
    <!-- 查询条件表单 -->
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item label="关键词">
        <el-input v-model="filters.key" placeholder="请输入关键词"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
      </el-form-item>
    </el-form>

    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!--列表-->
    <el-table :data="list" v-loading="listLoading" style="width: 100%">
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column label="用户名称">
        <template slot-scope="scope">
          <span>{{ scope.row.WxUserInfo.Name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="场馆ID" prop="VenueId"></el-table-column>
      <el-table-column label="评论时间" prop="CommentTime"></el-table-column>
      <el-table-column
        label="评论内容"
        prop="Comment"
        width="240"
      ></el-table-column>
      <el-table-column label="得分" prop="Score"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <!-- <el-button plain size="mini" @click="handleEdit(scope.row)"
            >编辑</el-button
          > -->
          <el-button type="danger" size="mini" @click="handleDel(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="mt16">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="page.pageSize"
        :total="total"
        style="float: right"
      >
      </el-pagination>
    </div>
  </section>
</template>
<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import { commentList, deleteComment } from "@/api/stadium/stadium";
export default {
  components: { Toolbar },
  data() {
    return {
      buttonList: [],
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      list: [],
      listLoading: false,
      total: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {},
      //新增界面数据
      addForm: {},
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {},
      //编辑界面数据
      editForm: {},
      // 新增查询条件
      filters: {
        key: "", // 添加关键词过滤字段
      },
    };
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getList();
  },
  methods: {
    handleDel(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      }).then(() => {
        deleteComment({
          id: row.Id,
        }).then((res) => {
          if (res.data.success) {
            this.initPage();
            this.$message({
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
          this.getList();
        });
      });
    },
    getList() {
      this.listLoading = true;
      let para = {
        page: this.page.currentPage,
        intPageSize: this.page.pageSize,
        key: this.filters.key, // 添加查询参数
      };
      commentList(para)
        .then((res) => {
          this.total = res.data.response.dataCount;
          this.list = res.data.response.data;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList();
    },
    initPage() {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.filters = {
        name: "",
      };
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    // 新增搜索方法
    handleSearch() {
      this.page.currentPage = 1; // 搜索时重置到第一页
      this.getList();
    },
  },
};
</script>
